import React from 'react';
import { CountdownHero } from './components/CountdownHero';
import { PhotoGallery } from './components/PhotoGallery';
export function App() {
  return <main className="min-h-screen w-full bg-[#faf6f1]" data-id="element-0">
      <CountdownHero data-id="element-1" />
      <PhotoGallery data-id="element-2" />

      {/* Footer */}
      <footer className="py-12 px-4 bg-[#2c1810] text-center" data-id="element-3">
        <p className="font-serif text-lg md:text-xl text-[#faf6f1]/90" data-id="element-4">
          Ich freue mich auf unseren Urlaub mein Schatz{' '}
          <span className="inline-block animate-pulse text-red-400" data-id="element-5">❤️</span>
        </p>
      </footer>
    </main>;
}